import { authService } from './authService';
import { getServerURL } from './config';

const SERVER_URL = getServerURL();

const request = async (path, options = {}) => {
  const response = await fetch(`${SERVER_URL}${path}`, {
    ...options,
    headers: {
      ...authService.getAuthHeaders(),
      ...(options.headers || {})
    }
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || `Payment request failed: ${response.status}`);
  }
  return data;
};

export const paymentReconciliationService = {
  async getPayments(filters = {}) {
    const query = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        query.set(key, value);
      }
    });
    return request(`/payment-reconciliation/payments?${query.toString()}`);
  },

  async getUnpaidOrders(search = '') {
    const query = new URLSearchParams({ limit: '50' });
    if (search.trim()) query.set('search', search.trim());
    return request(`/payment-reconciliation/unpaid-orders?${query.toString()}`);
  },

  async createManualPayment(payment) {
    return request('/payment-reconciliation/payments/manual', {
      method: 'POST',
      body: JSON.stringify(payment)
    });
  },

  async claimPayment(paymentId, orderId) {
    return request(`/payment-reconciliation/payments/${encodeURIComponent(paymentId)}/claim`, {
      method: 'POST',
      body: JSON.stringify({ order_id: orderId })
    });
  }
};
